export const flowNameHelper = (flowName: string) => {
  switch (flowName) {
    case 'mfe_oobe_warranty_replacement':
    case 'v2_printer_replacement_woobe':
    case 'v2_printer_replacement_moobe': {
      return 'replacementFlow'
    }

    case 'mfe_oobe_connect':
    case 'v3_connect_moobe':
    case 'v3_connect_woobe':
    case 'v3_connect_post_moobe':
    case 'v3_connect_post_woobe': {
      return 'connectFlow'
    }

    case 'v3_connect_finalize': {
      return 'connectFinalizeFlow'
    }

    case 'v2_ftm_moobe':
    case 'v2_ftm_woobe':
    case 'mfe_oobe_flip': {
      return 'ftmFlow'
    }

    case 'mfe_oobe_enroll':
    default: {
      return 'oobeEnrollFlow'
    }
  }
}
